/* eslint-disable no-use-before-define */
import { mobileFormFieldsTypes, textfieldTypes } from '../../../config/constants/mobileFormConstant';

const fieldErrors = {
  required: { message: 'thisFieldIsRequired' },
  wrongValue: { message: 'wrongValue' },
  conditionalValueRequired: { message: 'conditionalValueRequired' },
};

function validateDatetime(field, value) {
  if (value == null) return field.obligatory ? fieldErrors.required : null;
  return Number.isNaN(value?.getDate?.()) ? fieldErrors.required : null;
}

function checkTextValue(field, value) {
  if (!value?.trim?.().length) return field.obligatory ? fieldErrors.required : null;
}

function checkTextFieldValue(field, value) {
  const handlers = {
    [textfieldTypes.DATETIME.id]: validateDatetime,
    [textfieldTypes.DATE.id]: validateDatetime,
    default: checkTextValue,
  };
  const inputTypeId = field.typeTextField?.id ?? field.typeTextField;
  const handler = handlers[inputTypeId] ?? handlers.default;
  return handler(field, value);
}

function checkRadiosValue(field, value) {
  if (value == null) return field.obligatory ? fieldErrors.required : null;
  if (!value.idInput) return fieldErrors.required;
  const selectedOption = field.list?.find((item) => item.idInput === value.idInput);
  if (selectedOption == null) return fieldErrors.required;
  if (!selectedOption.conditional) {
    return null;
  }
  if (value.valueConditional == null) {
    return fieldErrors.conditionalValueRequired;
  }
  const hasError = checkFieldsValues(selectedOption.list, value.valueConditional);
  if (hasError) {
    return fieldErrors.conditionalValueRequired;
  }
  return null;
}

function checkListValues(field, value) {
  if (value?.nodes == null) return field.obligatory ? fieldErrors.required : null;
  if (!Array.isArray(value.nodes)) return fieldErrors.wrongValue;
  if (!field.obligatory) return null;
  const hasError = value.nodes.every((item) => {
    if (!item.nodes?.length && item.checked) return null;
    return checkListValues(field, item);
  });
  return hasError ? fieldErrors.required : null;
}

function checkFieldsValues(fields = [], values) {
  for (const field of fields) {
    const error = checkFieldValue(field, values[field.idInput]);
    if (error) return fieldErrors.wrongValue;
  }
  return null;
}

function checkCheckboxValue(field, value) {
  if (value != null && typeof value !== 'boolean') {
    return fieldErrors.wrongValue;
  }
  return value || !field.obligatory ? null : fieldErrors.required;
}

function checkCheckboxGroupValue(field, value) {
  if (!field.obligatory) return null;
  return field.list.some((item) => value[item.idInput]) ? null : fieldErrors.required;
}

function checkAssetValue(field, value) {
  if (value == null) {
    return field.obligatory ? fieldErrors.required : null;
  }
  return value._id != null ? null : fieldErrors.required;
}

function checkImagesValue(field, value) {
  if (value == null) return field.obligatory ? fieldErrors.required : null;
  if (!Array.isArray(value)) return fieldErrors.wrongValue;
  return value.length > 0 || !field.obligatory ? null : fieldErrors.required;
}

function checkActionValue(field, value) {
  const handler = actionHandlers[field.typeAction?.id];
  if (handler == null) return null;
  return handler(field, value);
}

function checkLocationDateValue(field, value) {
  if (value == null) return field.obligatory ? fieldErrors.required : null;
  if (
    value.markerCoords == null ||
    Number.isNaN(value.markerCoords.latitude) ||
    Number.isNaN(value.markerCoords.longitude) ||
    Number.isNaN(new Date(value.time))
  ) {
    return fieldErrors.required;
  }
  return null;
}

function checkLoopValue(field, value) {
  if (!value?.length) return field.obligatory ? fieldErrors.required : null;
  return value.some((item) => checkFieldsValues(field.list, item)) ? fieldErrors.wrongValue : null;
}

function checkAttachmentsValue(field, value) {
  if (value == null) return field.obligatory ? fieldErrors.required : null;
  if (!Array.isArray(value)) return fieldErrors.wrongValue;
  return value.length > 0 || !field.obligatory ? null : fieldErrors.required;
}

const fieldValidators = {
  [mobileFormFieldsTypes.text.id]: checkTextFieldValue,
  [mobileFormFieldsTypes.textArea.id]: checkTextValue,
  [mobileFormFieldsTypes.radios.id]: checkRadiosValue,
  [mobileFormFieldsTypes.list.id]: checkListValues,
  [mobileFormFieldsTypes.checkbox.id]: checkCheckboxValue,
  [mobileFormFieldsTypes.checkboxGroup.id]: checkCheckboxGroupValue,
  [mobileFormFieldsTypes.asset.id]: checkAssetValue,
  [mobileFormFieldsTypes.imgList.id]: checkImagesValue,
  [mobileFormFieldsTypes.action.id]: checkActionValue,
  [mobileFormFieldsTypes.loop.id]: checkLoopValue,
  [mobileFormFieldsTypes.attachments.id]: checkAttachmentsValue,
  default: () => null,
};

const actionHandlers = {
  [mobileFormFieldsTypes.locationDate.typeAction]: checkLocationDateValue,
};

export function checkFieldValue(field, value) {
  const handler = fieldValidators[field.id] ?? fieldValidators.default;
  const isValid = handler(field, value);
  return isValid;
}
